import { useEffect, useState } from "react";
import { WEBSOCKET } from "../config/index";

const useWebSocket = (username, isAuthenticated) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!isAuthenticated || !username) {
            return;
        }

        const ws = new WebSocket(`${WEBSOCKET}/ws/websocket/${username}/`);
        setSocket(ws);

        return () => {
            ws.close();
            setSocket(null);
        };
    }, [isAuthenticated, username]);

    return socket;
};

export default useWebSocket;
